import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'
import zh from 'react-intl/locale-data/zh'

import enTranslation from '../locales/en.json'
import zhTranslation from '../locales/zh.json'
import jaTranslation from '../locales/ja.json'

addLocaleData([...en, ...zh, ...ja])

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
const language = navigator.language ||
                  (navigator.languages && navigator.languages[0]) ||
                   navigator.language ||
                   navigator.userLanguage

// Split locales with a region code
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0]

// Try full locale, try locale without region code, fallback to 'en'
const locales = {
  en: enTranslation,
  zh: zhTranslation,
  ja: jaTranslation,
}
const messages = locales[languageWithoutRegionCode] || locales[language] || locales.zh

export {
  messages,
  language,
  IntlProvider,
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js